import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AppInstanceGrid } from '../../app/appInstanceGrid';
export const RootPage = () => {
    return _jsx(AppInstanceGrid, {});
};
